<template>
    <a href="#" class="nav-item dropdown-item" @click="logout">
        {{ $t('auth.log-out') }}
    </a>
</template>

<script>
    export default {

        props: {
            endpoint: {
                type: String,
                default: '/trax/api/auth/logout'
            },
            redirectRouteName: {
                type: String,
                default: 'login'
            }
        },

        methods: {
            logout() {
                this.error = null;
                axios.post(this.endpoint)
                    .then(resp => {
                        this.$router.push({ name: this.redirectRouteName });
                    })
            }
        }
    }
</script>
